export default function() {
    const allYouTubeLiteElements = document.querySelectorAll('lite-youtube')
    allYouTubeLiteElements.forEach(setupAutoplay)
}

function setupAutoplay(youtubeLite) {
    const observer = new MutationObserver(() => {
        const video = youtubeLite.querySelector('iframe')
        if (!video) return
        const config = { events: { onReady: e => e.target.playVideo() } }
        new YT.Player(video, config)
        observer.disconnect()
    })
    observer.observe(youtubeLite, { childList: true })
}

export function playVideo(containingDiv) {
    const ytLite = containingDiv.querySelector('lite-youtube')
    if (ytLite) return playYouTubeVideo(ytLite)

    const vimeoLite = containingDiv.querySelector('lite-vimeo')
    if (vimeoLite) return playVimeoVideo(vimeoLite)
}

export function stopVideo(containingDiv) {
    const ytLite = containingDiv.querySelector('lite-youtube')
    if (ytLite) return stopYouTubeVideo(ytLite)

    const vimeoLite = containingDiv.querySelector('lite-vimeo')
    if (vimeoLite) return stopVimeoVideo(vimeoLite)
}

function playYouTubeVideo(youtubeLite) {
    const video = youtubeLite.querySelector('iframe')
    const message = '{"event":"command","func":"playVideo","args":""}'
    if (video) return video.contentWindow.postMessage(message, '*')

    const playButton = youtubeLite.querySelector('button')
    if (playButton) playButton.click()
}

function playVimeoVideo(vimeoLite) {
    const video = vimeoLite.shadowRoot.querySelector('iframe')
    const message = '{"method":"play"}'
    if (video) return video.contentWindow.postMessage(message, '*')
    
    const playButton = vimeoLite.shadowRoot.querySelector('button')
    if (playButton) playButton.click()
}

function stopYouTubeVideo(ytLite) {
    const video = ytLite.querySelector('iframe')
    const message = '{"event":"command","func":"pauseVideo","args":""}'
    video?.contentWindow.postMessage(message, '*')
}

function stopVimeoVideo(vimeoLite) {
    const video = vimeoLite.shadowRoot.querySelector('iframe')
    const message = '{"method":"pause"}'
    video?.contentWindow.postMessage(message, '*')
}